import React, {useMemo} from 'react';
import styles from './NotFound.module.scss'
import {Button, Preloader} from "uikit";
import {NotFoundPropsInterface} from "@/views/Admin/Events/Event/Promocodes/NotFound/NotFound.props.interface";
import {useQueryRouter} from "@/hooks/useQueryRouter/useQueryRouter";
import {PromocodesSchema} from "@/views/Admin/Events/Event/Promocodes/Promocodes.schema";
import {useLocation} from "react-router-dom";

const NotFound = ({data, onReset}: NotFoundPropsInterface) => {
    const {isLoading} = data
    const {set} = useQueryRouter()
    const {search} = useLocation();
    const params = useMemo(() => new URLSearchParams(search), [search]);
    const tabs = data.tabs
    const content = tabs.includes(params.get('content') as string) ? params.get('content') : 'promocodes';

    const handleDropFilter = () => {
        set({
            filter: {},
            page: {number: PromocodesSchema.promocodes.meta.currentPage, size: PromocodesSchema.promocodes.meta.perPage}
        });
    };

    return (
        <div className={styles.container}>
            {isLoading && <Preloader/>}
            {!isLoading && <>
                <p>
                    {[
                        'Подходящие',
                        content === 'promocodes' && 'промокоды',
                        content === 'groups' && 'группы',
                        'не найдены'
                    ].filter(Boolean).join(' ')}
                </p>
                <Button
                    size={'small'}
                    type={'primary'}
                    theme={'default'}
                    htmlType={'button'}
                    onClick={handleDropFilter}>
                    Показать все
                </Button>
            </>}
        </div>
    );
};

export default NotFound;
